import { UserDetails } from '../types/userDetails.types'

export const getUserDisplayName = (user: UserDetails | null | undefined): string => {
  if (!user) {
    return ''
  }

  return (user.name || user.displayName || user.email || '').trim()
}
